<template>
  <Dialog title="Aktiviteter påvirkes af udmeldelsen" confirm="Godkend ændringer og udmeld" data-testid="confirm-dialog" @close="(value) => $emit('close', value)">
    <template #content>
      <div class="flex flex-col mt-6 gap-4">
        <div v-if="overlappingRecords.length">
          <p class="text-gray-700 font-medium">
            Slutdatoer på disse aktiviteter vil blive nulstillet og opdateret med den faktiske slutdato {{ $filters.formatDate(endDate) }}
          </p>
          <ul class="list-disc pl-4 mt-2 space-y-1">
            <li v-for="record in overlappingRecords" :key="record.name + record.startDate" class="text-gray-500">
              {{ typeMap[record.type] }} {{ record.name }} - nuværende slutdato: {{ $filters.formatDate(record.endDate) }}
            </li>
          </ul>
        </div>
        <div v-if="futureRecords.length">
          <p class="text-gray-700 font-medium">Disse aktiviteter starter efter udmeldelsesdatoen og vil blive slettet</p>
          <ul class="list-disc pl-4 mt-2 space-y-1">
            <li v-for="record in futureRecords" :key="record.name + record.startDate" class="text-gray-500">
              {{ typeMap[record.type] }} {{ record.name }} - startdato: {{ $filters.formatDate(record.startDate) }}
            </li>
          </ul>
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "~/components/dialogs/Dialog";

export default {
  components: { Dialog },

  props: {
    endDate: {
      type: Date,
      required: true,
    },

    records: {
      type: Array,
      required: true,
    },

    loading: Boolean,
  },

  emits: ["close"],

  computed: {
    typeMap() {
      return {
        WorkExperiencePlan: "Praktikplan",
        WorkExperience: "Praktik",
        EducationModuleAttendance: "Undervisningsaktivitet",
        "Mentor::PersonStay": "Mentorforløb",
      };
    },

    overlappingRecords() {
      return this.records.filter((r) => new Date(r.startDate) <= this.endDate);
    },

    futureRecords() {
      return this.records.filter((r) => new Date(r.startDate) > this.endDate);
    },
  },
};
</script>
